export default __webpack_public_path__ + "static/518-e496f515c704ef4737faa0572e142d67.gif";